/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_PaddingInputs */

const de__field_padding = /** @type {(inputs: _Field_PaddingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Padding`)
};

/**

* @param {_Field_PaddingInputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
export const _field_padding = /** @type {((inputs?: _Field_PaddingInputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_PaddingInputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return de__field_padding(inputs)
});